var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPegapontos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.34 17.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#484442;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P\\xE1gina_3",
    "data-name": "P\\xE1gina 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.06,10.45,11.93,11a1.59,1.59,0,1,0,.36,1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.15,
    cy: 7.17,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.89,
    cy: 6.13,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.2,
    cy: 9.87,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.66,13.5a.49.49,0,0,1-.49-.42,6.33,6.33,0,0,1-.07-1,6.49,6.49,0,0,1,1-3.54A6.6,6.6,0,0,1,7.89,6.19a.49.49,0,0,1,.65.25.48.48,0,0,1-.24.65A5.56,5.56,0,0,0,6,9.11a5.49,5.49,0,0,0-.89,3,4.73,4.73,0,0,0,.07.83.5.5,0,0,1-.42.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPegapontos);
export default __webpack_public_path__ + "static/media/logo-pegapontos.285349f898effbb09dd91ee7911f4bcc.svg";
export { ForwardRef as ReactComponent };